<template>
  <div>
    <h2 qid="notifications-page-title">
      {{ $t('notifications.page_title') }}
    </h2>
    <br>
    <div class="card">
      <div class="card-body">
        <div>
          <div v-if="unread_items.length">
            <div v-for="notification in unread_items" class="notification-item">
              <ValidationNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\Validation'"/>
              <OwnerNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\Owner'"/>
              <ReportNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ReportGenerated'"/>
              <ProjectCreatedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ProjectCreated'"/>
              <ProjectCompletedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ProjectCompleted'"/>
              <ExportNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ExportGenerated'"/>
              <PolicyDocumentAddedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentAdded'"/>
              <PolicyDocumentUpdatedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentUpdated'"/>
              <PolicyDocumentPublishedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentPublished'"/>
              <PolicyDocumentReadyToPublishNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentReadyToPublish'"/>
              <AttachmentNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\AttachmentsGenerated'"/>

              <CollectionTaskComment :notification="notification" v-if="notification.type === 'App\\Notifications\\CollectionTaskComment'"/>
              <CollectionTaskCompleted :notification="notification" v-if="notification.type === 'App\\Notifications\\CollectionTaskCompleted'"/>
              <CollectionTaskReopened :notification="notification" v-if="notification.type === 'App\\Notifications\\CollectionTaskReopened'"/>
              <TaskComment :notification="notification" v-if="notification.type === 'App\\Notifications\\TaskComment'"/>
              <ProjectOverdueNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ProjectOverdue'"/>
            </div>
          </div>
          <div v-if="read_items">
            <div v-for="notification in read_items" class="notification-item">
              <ValidationNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\Validation'"/>
              <OwnerNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\Owner'"/>
              <ReportNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ReportGenerated'"/>
              <ProjectCreatedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ProjectCreated'"/>
              <ProjectCompletedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ProjectCompleted'"/>
              <ExportNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ExportGenerated'"/>
              <PolicyDocumentAddedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentAdded'"/>
              <PolicyDocumentUpdatedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentUpdated'"/>
              <PolicyDocumentPublishedNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentPublished'"/>
              <PolicyDocumentReadyToPublishNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\PolicyDocumentReadyToPublish'"/>
              <AttachmentNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\AttachmentsGenerated'"/>

              <CollectionTaskComment :notification="notification" v-if="notification.type === 'App\\Notifications\\CollectionTaskComment'"/>
              <CollectionTaskCompleted :notification="notification" v-if="notification.type === 'App\\Notifications\\CollectionTaskCompleted'"/>
              <CollectionTaskReopened :notification="notification" v-if="notification.type === 'App\\Notifications\\CollectionTaskReopened'"/>
              <TaskComment :notification="notification" v-if="notification.type === 'App\\Notifications\\TaskComment'"/>
              <ProjectOverdueNotification :notification="notification" v-if="notification.type === 'App\\Notifications\\ProjectOverdue'"/>
            </div>
          </div>
        </div>
        <InfiniteLoading @infinite="loadingHandler">
          <template slot="no-results">
            <span>
              {{ $t('system.no_notifications') }}
            </span>
          </template>
        </InfiniteLoading>
      </div>
    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import ValidationNotification from '@/components/notification/ValidationNotification.vue';
import OwnerNotification from '@/components/notification/OwnerNotification.vue';
import ReportNotification from '@/components/notification/ReportGeneratedNotification.vue';
import ProjectCreatedNotification from '@/components/notification/ProjectCreatedNotification.vue';
import ProjectCompletedNotification from '@/components/notification/ProjectCompletedNotification.vue';
import InfiniteLoading from 'vue-infinite-loading';
import ExportNotification from '@/components/notification/ExportNotification.vue';
import PolicyDocumentAddedNotification from '@/components/notification/PolicyDocumentAddedNotification.vue';
import PolicyDocumentUpdatedNotification from '@/components/notification/PolicyDocumentUpdatedNotification.vue';
import PolicyDocumentPublishedNotification from '@/components/notification/PolicyDocumentPublishedNotification.vue';
import PolicyDocumentReadyToPublishNotification from '@/components/notification/PolicyDocumentReadyToPublishNotification.vue';
import AttachmentNotification from '@/components/notification/AttachmentsGeneratedNotification.vue';
import CollectionTaskComment from '@/components/notification/CollectionTaskComment.vue';
import CollectionTaskCompleted from '@/components/notification/CollectionTaskCompleted.vue';
import CollectionTaskReopened from '@/components/notification/CollectionTaskReopened.vue';
import TaskComment from '@/components/notification/TaskComment.vue';
import ProjectOverdueNotification from '@/components/notification/ProjectOverdueNotification.vue';
export default {
  name: 'NotificationPage',
  data: function() {
    return {
      activeNavbar: this.$store.state.activeNavbar,
      read_items: [],
      unread_items: [],
      currentPage: 1,
      totalRows: 0,
      loading: true,
      page: 1
    }
  },
  props: {

  },
  components: {
    ValidationNotification,
    OwnerNotification,
    ReportNotification,
    InfiniteLoading,
    ProjectCreatedNotification,
    ProjectCompletedNotification,
    ExportNotification,
    PolicyDocumentAddedNotification,
    PolicyDocumentUpdatedNotification,
    PolicyDocumentPublishedNotification,
    PolicyDocumentReadyToPublishNotification,
    AttachmentNotification,
    CollectionTaskComment,
    CollectionTaskCompleted,
    CollectionTaskReopened,
    TaskComment,
    ProjectOverdueNotification
  },
  computed: {
    getNavType() {
          return this.$store.state.activeNavbar
    },
    getClient() {
      return this.$store.state.client
    }
  },
  watch: {

  },
  methods: {
    loadingHandler($state) {
      let self = this

      piincHttp.get('users/me/notifications', { params:
      {
          page: this.page,
      }
      }).then(({ data }) => {
        if (data.read_items.data.length) {
          self.page += 1;
          self.read_items.push(...data.read_items.data);
          if ($state) {
            $state.loaded();
          }
        } else {
          if ($state) {
            $state.complete();
          }
        }
      });

    }
  },
  created () {
    let self = this;
  }
}
</script>

<style scoped lang="scss">

</style>
